import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const containerStyle = { maxWidth: 800, margin: '40px auto', padding: 24, border: '1px solid #ddd', borderRadius: 10, background: '#fafafa' };
const inputStyle = { width: '100%', padding: 10, marginBottom: 0, boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: 6, fontSize: 14 };
const labelStyle = { display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 14 };
const btnPrimary = { padding: '12px 20px', background: '#28a745', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15, width: '100%' };
const btnSecondary = { padding: '10px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' };

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export default function AddStudent() {
  const navigate = useNavigate();
  
  const initialForm = {
    student_id: '', 
    username: '', 
    password: '', 
    first_name: '', 
    last_name: '',
    school_name: '',
    age: '',
    current_grade: '',
    gender: 'M', 
    date_of_birth: ''
  };

  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    setMessage({ type: '', text: '' });

    try {
      const res = await fetch(`${API_BASE}/admin/students`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to add student');

      setMessage({ type: 'success', text: '✅ Student added successfully!' });
      setFormData(initialForm); // Reset form
    } catch (err) {
      setMessage({ type: 'error', text: `❌ ${err.message}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>Add New Student</h2>
        <button onClick={() => navigate('/admin/dashboard')} style={btnSecondary}>← Back</button>
      </div>

      {message.text && (
        <div style={{ padding: 12, background: message.type === 'success' ? '#d4edda' : '#f8d7da', color: message.type === 'success' ? '#155724' : '#721c24', borderRadius: 6, marginBottom: 15, fontWeight: 500 }}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* Row 1: Account Details */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15, marginBottom: 15 }}>
          <div>
            <label style={labelStyle}>Student ID *</label>
            <input style={inputStyle} name="student_id" value={formData.student_id} onChange={handleChange} placeholder="e.g. STU001" required />
          </div>
          <div>
            <label style={labelStyle}>Username *</label>
            <input style={inputStyle} name="username" value={formData.username} onChange={handleChange} placeholder="Login username" required />
          </div>
        </div>

        {/* Row 2: Personal Names */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15, marginBottom: 15 }}>
          <div>
            <label style={labelStyle}>First Name *</label>
            <input style={inputStyle} name="first_name" value={formData.first_name} onChange={handleChange} required />
          </div>
          <div>
            <label style={labelStyle}>Last Name *</label>
            <input style={inputStyle} name="last_name" value={formData.last_name} onChange={handleChange} required />
          </div>
        </div>

        {/* Row 3: School & Grade Info */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 15, marginBottom: 15 }}>
          <div>
            <label style={labelStyle}>Name of School</label>
            <input style={inputStyle} name="school_name" value={formData.school_name} onChange={handleChange} placeholder="e.g. Springfield Elementary" />
          </div>
          <div>
            <label style={labelStyle}>Age</label>
            <input style={inputStyle} type="number" name="age" value={formData.age} onChange={handleChange} placeholder="e.g. 10" min="1" max="99" />
          </div>
          <div>
            <label style={labelStyle}>Current Grade</label>
            <input style={inputStyle} name="current_grade" value={formData.current_grade} onChange={handleChange} placeholder="e.g. Grade 5" />
          </div>
        </div>

        {/* Row 4: Security & Demographics */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 15, marginBottom: 15 }}>
          <div>
            <label style={labelStyle}>Password *</label>
            <input style={inputStyle} type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Min 6 characters" required />
          </div>
          <div>
            <label style={labelStyle}>Gender *</label>
            <select style={inputStyle} name="gender" value={formData.gender} onChange={handleChange} required>
              <option value="M">Male</option>
              <option value="F">Female</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Date of Birth *</label>
            <input style={inputStyle} type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} required />
          </div>
        </div>

        {/* Submit Button */}
        <div style={{ marginTop: 20 }}>
          <button type="submit" disabled={loading} style={{ ...btnPrimary, opacity: loading ? 0.6 : 1, transition: 'opacity 0.2s' }}>
            {loading ? 'Saving...' : 'Save Student'}
          </button>
        </div>
      </form>
    </div>
  );
}